// Trigger deployment - Docker build fixes and tenant API improvements
// //

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import React from "react";
import ReactDOM from "react-dom/client";
import { Toaster } from "react-hot-toast";
import { OktaAuth } from "@okta/okta-auth-js";
import { OktaProvider, createOktaConfig } from "@vmlmap/shared-ui/auth";

import App from "./components/App";
import { setOktaAuth } from "./api/client";
import { TenantProvider } from "./contexts/TenantContext";
import "./styles.css";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      retry: 3, // Force deployment trigger
    },
  },
});

const oktaConfig = createOktaConfig({
  issuer: 'https://wpp.okta.com/oauth2/default',
  clientId: import.meta.env.VITE_OKTA_CLIENT_ID || '',
  disableAuth: import.meta.env.VITE_DISABLE_AUTH === 'true',
});

let oktaAuth: OktaAuth | undefined;
if (!oktaConfig.disableAuth) {
  oktaAuth = new OktaAuth(oktaConfig);
  setOktaAuth(oktaAuth);
}

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(
  <React.StrictMode>
    <OktaProvider config={oktaConfig} oktaAuth={oktaAuth}>
      <QueryClientProvider client={queryClient}>
        <TenantProvider>
          <App />
          {/* Bottom-centre so toasts never sit over the top-right close button of
              full-screen overlays such as the asset library detail view. */}
          <Toaster position="bottom-center" />
        </TenantProvider>
      </QueryClientProvider>
    </OktaProvider>
  </React.StrictMode>
);
